export default function accordions () {
  const elAccordionToggles = document.querySelectorAll('.js-accordion')

  const setMaxHeights = () => {
    elAccordionToggles.forEach((elToggle) => {
      const elAccordion = elToggle.parentElement
      const elContent = elAccordion.querySelector('.Accordion-content')
      const scrollHeight = elContent.scrollHeight
      elContent.style.maxHeight = scrollHeight + 'px'
    })
  }

  const updateTabindices = () => {
    elAccordionToggles.forEach((elToggle) => {
      const elAccordion = elToggle.parentElement
      const elContent = elAccordion.querySelector('.Accordion-content')
      const elLinks = elContent.querySelectorAll('a')
      elLinks.forEach((elLink) => {
        if (elAccordion.dataset.state === 'closed') {
          elLink.tabIndex = -1
        } else {
          elLink.tabIndex = 0
        }
      })
    })
  }

  if (elAccordionToggles) {
    setMaxHeights()
    updateTabindices()

    window.addEventListener('resize', () => {
      setMaxHeights()
    })

    elAccordionToggles.forEach((elToggle) => {
      elToggle.addEventListener('click', async (evt) => {
        evt.preventDefault()
        const elAccordion = elToggle.parentElement

        if (elAccordion.dataset.state === 'closed') {
          elAccordion.classList.remove('Accordion--closed')
          elAccordion.dataset.state = 'open'
        } else {
          elAccordion.classList.add('Accordion--closed')
          elAccordion.dataset.state = 'closed'
        }
        updateTabindices()
      })
    })
  }
}